import React from "react";
import axios from "axios";
import "./History.css";
import "./ManualEntry.css";
import Modal from "react-responsive-modal";
import { Col } from "react-bootstrap";
import { translations } from "../containers/assets/translations";
import { B2B_PROXY } from "../containers/assets/config";
import { FormControl, ControlLabel, Radio } from "react-bootstrap";
import { ToastContainer, ToastStore } from "react-toasts";

export default class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.closeReports = this.closeReports.bind(this);
    this.Show = this.Show.bind(this);
    this.FetchPdfReport = this.FetchPdfReport.bind(this);
    this.state = {
      ItineraryID: props.ItineraryID,
      SailID: props.SailID,
      userName: localStorage.getItem("userName"),
      id: localStorage.getItem("userId"),
      password: localStorage.getItem("ps"),
      lang:
        localStorage.getItem("lang") === "EN" ||
        localStorage.getItem("lang") === "FR" ||
        localStorage.getItem("lang") === "ES"
          ? localStorage.getItem("lang")
          : "EN",
      openReports: this.props.OpenReports,
      ReportRadio: "",
      ReportCombo: "Issued",
      url: "",
      statuscode: "",
    };
  }

  closeReports = () => {
    this.setState({ statuscode: "" });
    this.props.onClickReportsButton();
  };

  TicketTypeME = (e) => {
    this.setState({ ReportRadio: e.target.id });
  };

  handleChangeCombo = (e) => {
    this.setState({ ReportCombo: e.target.value });
  };

  Show = () => {
    let Data = {
      Itinerary: this.props.ItineraryID,
      Sail: this.props.SailID,
      user: this.props.user,
      id: this.props.id,
      password: this.props.password,
      lang: "EN",
      ReportRadio: this.state.ReportRadio,
      ReportCombo: this.state.ReportCombo,
    };
    axios
      .post(B2B_PROXY + "/Reports", {
        Data,
      })
      .then((res) => {
        this.setState({ StatusPDF: res.data.StatusMessage });
        if (res.data.StatusCode !== "000") {
          ToastStore.error(res.data.StatusMessage, 5000);
        } else {
          this.setState({ statuscode: res.data.StatusCode });
          this.setState({ url: res.data.StatusMessage });
        }
      });
  };

  FetchPdfReport = () => {
    window.open(B2B_PROXY + "/file.pdf", "_blank");
  };

  render() {
    var lang = this.state.lang;
    //var company = this.state.itinerary.CompanyDescription;
    return (
      <div>
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={
            // @ts-ignore
            ToastContainer.POSITION.TOP_CENTER
          }
        />
        <Modal open={this.props.OpenReports} onClose={this.closeReports} center>
          <div className="mod">
            <div className="col-md-12">
              <Col md={12}>
                <ControlLabel />
                <FormControl
                  componentClass="select"
                  className=""
                  onChange={this.handleChangeCombo.bind(this)}
                >
                  <option value="Issued" id="Issued">
                    Issued Boarding Cards
                  </option>
                  ;
                  <option value="Embarked" id="Embarked">
                    Already Embarked
                  </option>
                  ;
                  <option value="NShown" id="NShown">
                    Non Show
                  </option>
                  ;
                </FormControl>
              </Col>
              <Col md={12}>
                <Col md={4} className="center">
                  <Radio
                    id="All"
                    name="isPass"
                    onClick={this.TicketTypeME.bind(this)}
                    inline
                  >
                    <span className="glyphicon glyphicon-record GlyphiconMANENTR" />
                    <span className="labelRadio">All</span>
                  </Radio>
                </Col>
                <Col md={4} className="center">
                  <Radio
                    id="Passenger"
                    name="isPass"
                    onClick={this.TicketTypeME.bind(this)}
                    inline
                  >
                    <span className="glyphicon glyphicon-record GlyphiconMANENTR" />
                    <span className="labelRadio">
                      {translations[lang]["Passenger"]}
                    </span>
                  </Radio>
                </Col>
                <Col md={4} className="center">
                  <Radio
                    id="Vehicle"
                    name="isPass"
                    onClick={this.TicketTypeME.bind(this)}
                    inline
                  >
                    <span className="glyphicon glyphicon-record GlyphiconMANENTR" />
                    <span className="labelRadio">
                      {translations[lang]["Vehicle"]}
                    </span>
                  </Radio>
                </Col>
              </Col>
              {this.state.statuscode === "000" ? (
                <Col md={12}>
                  <button
                    className="btn btn-primary btn btn-lg"
                    onClick={this.FetchPdfReport}
                  >
                    Report PDF
                  </button>
                </Col>
              ) : null}
            </div>
            <div className="col-md-12">
              <div className="col-md-6">
                <button
                  className="btn btn-primary btn btn-lg"
                  onClick={this.closeReports}
                >
                  Close
                </button>
              </div>

              <div className="col-md-6">
                {this.state.ReportRadio !== "" ? (
                  <button
                    className="btn btn-primary btn btn-lg"
                    onClick={this.Show}
                  >
                    Show
                  </button>
                ) : (
                  <button
                    className="btn btn-primary btn btn-lg"
                    disabled
                    onClick={this.Show}
                  >
                    Show
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reports.js